import { render, staticRenderFns } from "./userPane.vue?vue&type=template&id=f2662f44"
import script from "./userPane.vue?vue&type=script&lang=js"
export * from "./userPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports